import { PageContent } from "../../components/organisms/Contents/PageContent";
import { FormEvent, useCallback, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { showAlert } from "../../components/containers/Alert";

import useContextMenu from "../../common/hooks/useContextMenu";
import { confirmDialog } from "../../components/containers/ConfirmDialog";
import ContextMenu from "../../components/molecules/ContextMenu";
import {
  chartSelectedTabIndexSate,
  ChartTab,
  chartTabseState,
} from "../../common/states/chart";
import CustomTabTemplate from "../../components/template/CustomTabTemplate";

interface TrendSearchInputsType {
  shipNo?: string;
  shipTypeNo?: string;
  sensorCode?: string;
  mcyName?: string;
  lowMcyName?: string;
  unit?: string;
  startDate?: string;
  endDate?: string;
}

export const TrendPage = () => {
  // 아래의 chartTabs의 persist를 주석처리하면 새로고침 및 재방문시 초기화
  const [chartTabs, setChartTabs] = useRecoilState<ChartTab[]>(chartTabseState);
  const [selectedTabIndex, setSelectedTabIndex] = useRecoilState<number>(
    chartSelectedTabIndexSate
  );

  const {
    contextMenu,
    handleContextMenu,
    handleOpenInNewTab,
    handleOpenInNewWindow,
  } = useContextMenu();

  // 핸들러 함수들을 useCallback으로 메모이제이션
  const handleCloseTab = useCallback(
    async (index: number) => {
      const isConfirm = await confirmDialog({
        text: "선택한 차트를 닫으시겠습니까?",
      });

      if (!isConfirm) return;
      setChartTabs(chartTabs.filter((tab) => tab.index !== index));
    },
    [chartTabs, setChartTabs]
  );

  // 차트 탭 추가
  const handleAddTab = useCallback(() => {
    if (chartTabs.length >= 12) {
      showAlert("최대 12개까지만 추가 가능합니다.");
      return;
    }

    const maxIndex = chartTabs.reduce(
      (acc, cur) => (acc > cur.index ? acc : cur.index),
      0
    );

    // 새 탭 추가
    const newTab = {
      index: maxIndex + 1,
      name: `차트${maxIndex + 1}`,
      chartTimes: [], // 빈 배열로 명시적 초기화
      chartOptions: [], // 빈 배열로 명시적 초기화
      chartSearch: {}, // 빈 객체로 명시적 초기화
      trendId: undefined, // trendId 명시적으로 undefined 설정
    };

    setChartTabs((prev) => [...prev, newTab]);

    // 새 탭으로 즉시 이동
    setSelectedTabIndex(maxIndex + 1);
  }, [chartTabs, setChartTabs, setSelectedTabIndex]);

  // 차트 조건 불러올 때마다 차트 id 값 변경
  const updateTrendId = useCallback(
    (trendId: number) => {
      setChartTabs(
        chartTabs.map((tab) =>
          tab.index === selectedTabIndex
            ? { ...tab, trendId: trendId }
            : { ...tab }
        )
      );
    },
    [chartTabs, selectedTabIndex, setChartTabs]
  );
  return (
    <PageContent depth01Title="데이터 분석" depth02Title="동일시간 차트 분석">
      <>
        <CustomTabTemplate
          selectedTab={selectedTabIndex}
          setSelectedTab={setSelectedTabIndex}
          onContextMenu={handleContextMenu}
          tabs={chartTabs}
          addTab={handleAddTab}
          closeTab={handleCloseTab}
          updateTrendId={updateTrendId}
        />

        <ContextMenu
          handleOpenInNewTab={handleOpenInNewTab}
          handleOpenInNewWindow={handleOpenInNewWindow}
          visible={contextMenu.visible}
          x={contextMenu.x}
          y={contextMenu.y}
        />
      </>
    </PageContent>
  );
};
